import React from "react";

type TabPanelProps = {
  selectedTabIndex: number;
  index?: number;
  children?: React.ReactNode;
};

export const TabPanel: React.FunctionComponent<TabPanelProps> = ({
  selectedTabIndex,
  index,
  children,
}) => {
  if (selectedTabIndex === index) {
    return <div>{children}</div>;
  }
  return null;
};
